export default __webpack_public_path__ + "static/N0098-305abfb989a424c820e8016bb60cda7c.png";